"use client";

import { useEffect, useState } from "react";
import {
  resolveParticipantRuntimePolicy,
  type ParticipantRuntimePolicy,
} from "@/lib/runtime";

export function useParticipantRuntimePolicy(enabled = true) {
  const [policy, setPolicy] = useState<ParticipantRuntimePolicy | null>(null);

  useEffect(() => {
    if (!enabled) return;

    const evaluate = () => {
      setPolicy(resolveParticipantRuntimePolicy());
    };

    evaluate();

    const handleVisibilityChange = () => {
      if (document.visibilityState !== "visible") return;
      evaluate();
    };

    window.addEventListener("pageshow", evaluate);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("pageshow", evaluate);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [enabled]);

  return policy;
}
